<main class="page-container">
   <div class="header-wrapper">
      <h2 class="title">Quantum Emulators</h2>
      <p class="description">{{descriptionText1}}</p>

      <div class="header-grid">
         
         <div class="left-col">
            <button class="desp-button" (click)="onCreateNewNotebook()">Create a Quantum Emulator</button>
         </div>
         <div class="right-col">
            <div class="custom-search-bar">
               <input
               type="text"
               placeholder="Search across all fields..."
               [(ngModel)]="searchText"
               (ngModelChange)="applyFilter()" />
               <button (click)="applyFilter()" aria-label="Search">
               <i data-feather="search" id="search-icon"></i>
               </button>
            </div>
         </div>
      </div>
   </div>
   <mat-card>
      <div class="table-scroll-container">
         <mat-table [dataSource]="dataSource" class="notebook-table" >
            <!-- Name  -->
            <ng-container matColumnDef="name">
               <mat-header-cell
               *matHeaderCellDef
               (click)="sortData('name')"
               class="sortable-header"
               >
               Name
               <i [attr.data-feather]="sortedColumn === 'name' 
                  ? (sortDirection === 'asc' ? 'chevron-down' : 'chevron-up') 
                  : 'chevron-down'"
                  class="sort-icon">
               </i>
               </mat-header-cell>
               <mat-cell *matCellDef="let notebook" [ngClass]="{ 'highlight-column': sortedColumn === 'name' }">
               <a class="notebook-link" (click)="goToDetails(notebook.id)">
               {{ notebook.name }}
               </a>
               </mat-cell>
            </ng-container>
            <!-- Environment -->
            <ng-container matColumnDef="environment">
               <mat-header-cell *matHeaderCellDef (click)="sortData('environment')" class="sortable-header">
               Environment
               <i [attr.data-feather]="sortedColumn === 'environment' 
                  ? (sortDirection === 'asc' ? 'chevron-down' : 'chevron-up') 
                  : 'chevron-down'"
                  class="sort-icon">
               </i>
               </mat-header-cell>
               <mat-cell *matCellDef="let notebook" [ngClass]="{ 'highlight-column': sortedColumn === 'environment' }">
               {{ notebook.environment }}
               </mat-cell>
            </ng-container>
            <!-- Version  -->
            <ng-container matColumnDef="version">
               <mat-header-cell *matHeaderCellDef (click)="sortData('version')" class="sortable-header">
               Version
               <i [attr.data-feather]="sortedColumn === 'version' 
                  ? (sortDirection === 'asc' ? 'chevron-down' : 'chevron-up') 
                  : 'chevron-down'"
                  class="sort-icon">
               </i>
               </mat-header-cell>
               <mat-cell *matCellDef="let notebook" [ngClass]="{ 'highlight-column': sortedColumn === 'version' }">
               {{ notebook.version }}
               </mat-cell>
            </ng-container>
            <!-- CPU -->
            <ng-container  matColumnDef="cpu">
               <mat-header-cell *matHeaderCellDef (click)="sortData('cpu')" class="sortable-header narroew-cell">
               CPU
               <i [attr.data-feather]="sortedColumn === 'cpu' 
                  ? (sortDirection === 'asc' ? 'chevron-down' : 'chevron-up') 
                  : 'chevron-down'"
                  class="sort-icon">
               </i>
               </mat-header-cell>
               <mat-cell class="narrow-cell" *matCellDef="let notebook" [ngClass]="{ 'highlight-column': sortedColumn === 'cpu' }">
               {{ notebook.cpu }}
               </mat-cell>
            </ng-container>
            <!-- Operating time  -->
            <ng-container matColumnDef="runtime">
               <mat-header-cell *matHeaderCellDef (click)="sortData('runtime')" class="sortable-header">
               Operating time
               <i [attr.data-feather]="sortedColumn === 'runtime' 
                  ? (sortDirection === 'asc' ? 'chevron-down' : 'chevron-up') 
                  : 'chevron-down'"
                  class="sort-icon">
               </i>
               </mat-header-cell>
               <mat-cell *matCellDef="let notebook" [ngClass]="{ 'highlight-column': sortedColumn === 'runtime' }">
               {{ notebook.runtime }}
               </mat-cell>
            </ng-container>
            <!-- Status  -->
            <ng-container matColumnDef="status">
               <mat-header-cell *matHeaderCellDef (click)="sortData('status')" class="sortable-header">
               Status
               <i [attr.data-feather]="sortedColumn === 'status' 
                  ? (sortDirection === 'asc' ? 'chevron-down' : 'chevron-up') 
                  : 'chevron-down'"
                  class="sort-icon">
               </i>
               </mat-header-cell>
               <mat-cell *matCellDef="let notebook" [ngClass]="{ 'highlight-column': sortedColumn === 'status' }">
               {{ notebook.status }}
               </mat-cell>
            </ng-container>
<!-- Access -->
<ng-container matColumnDef="access">
  <mat-header-cell *matHeaderCellDef class="access-cell">
    Access
  </mat-header-cell>

  <mat-cell *matCellDef="let notebook" class="access-cell">
    <ng-container *ngIf="isRunning(notebook); else disabledLaunch">
      <a
        [href]="notebook.accessUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="desp-button launch-button"
      >
        Launch
      </a>
    </ng-container>

    <ng-template #disabledLaunch>
      <button
        type="button"
        class="desp-button launch-button"
        disabled
      >
        Launch
      </button>
    </ng-template>
  </mat-cell>
</ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
               <mat-header-cell  *matHeaderCellDef> Action </mat-header-cell>
               <mat-cell *matCellDef="let row">
                  <app-notebook-actions-menu 
                  [notebook]="row"
                  (start)="onStartNotebook($event)"
                  (stop)="onStopNotebook($event)"
                  (delete)="deleteNotebook($event)"
                  (details)="goToDetails($event)"
                  > 
                  </app-notebook-actions-menu>
               </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
         </mat-table>
      </div>
      <div class="table-scroll-container"></div>
   </mat-card>
   <mat-paginator
   [length]="total"
   [pageSize]="pageSize"
   [pageSizeOptions]="pageSizeOptions"
   (page)="onPageEvent($event)">
   </mat-paginator>
</main>